import request from '@/utils/request'

// 订单列表
export const order_list=(data)=>{
  return request({
    url: '/erp/order-total/list',
    method: 'post',
    data
  })
}

// 订单—收银
export const order_update=(data)=>{
  return request({
    url: '/erp/order-total/create',
    method: 'post',
    data
  })
}
// 订单—作废
export const order_delete=(data)=>{
  return request({
    url: '/erp/order-total/scrap',
    method: 'post',
    data
  })
}

// 订单—改单
export const order_edit=(data)=>{
  return request({
    url: '/erp/order-total/edit-order',
    method: 'post',
    data
  })
}


// 订单—打印
export const order_print=(data)=>{
  return request({
    url: '/erp/order-total/print',
    method: 'post',
    data
  })
}

// 订单—获取赊欠id
export const order_getCredit=(data)=>{
  return request({
    url: '/erp/order-total/get-credit',
    method: 'post',
    data
  })
}
